module.exports = __webpack_public_path__ + "static/router-eb14fffcd73294aa8284a1098ca466fd.png";